import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '../../environment/environment.service';
import { Observable } from 'rxjs';
import { IBenefitDetails } from '../models/benefit.interface';

@Injectable({
  providedIn: 'root'
})
export class BenefitService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);
  private apiUrl = this.environmentService.environment.url.apiUrl;

  public getAllBenefitDetails(policyGroupID: number, isDomestic: boolean): Observable<IBenefitDetails[]> {
    return this.http.post<IBenefitDetails[]>(this.apiUrl + '/benefits/detailsByProduct', {
      PolicyGroupID: policyGroupID,
      IsDomestic: isDomestic
    });
  }
}
